@if(visible()) {
  <context-message class="full-width-message" messageType="error" (dismiss)="visible.set(false)">
    <p class="text--large">
      Den här vyn visar WOO:s eget lager, som inte längre avgör vad som går att boka. Bokningsbarhet kontrolleras mot
      OMS (baserat på TVbeat). Se <a class="text--large text--underline" [routerLink]="['/buylist-oms']">Köplista OMS</a>
      för aktuella maxuttag.
    </p>
  </context-message>
}
